import { CommonProps, InputField, Text } from '@beat-venues/ui/react';
import { Dispatch, ReactElement, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface NewUserFormProps extends CommonProps {
    birthday: string;
    setBirthday: Dispatch<SetStateAction<string>>;
    isUser: boolean;
}

export const BirthdayPicker = ({
    birthday,
    setBirthday,
    isUser,
}: NewUserFormProps): ReactElement => {
    const { t } = useTranslation();
    const [isBDFocused, setIsBDFocused] = useState(false);

    const maxDate = new Date().toISOString().split('T')[0];

    return (
        <div>
            <InputField
                className="mb-6"
                label={t(`userAccount.birthdate`) || ''}
                max={maxDate}
                value={birthday}
                name="birthdate"
                required={true}
                type="date"
                readOnly={isUser}
                onChange={(newValue) => setBirthday(newValue)}
                onFocus={() => setIsBDFocused(true)}
            />
            {isBDFocused && (
                <Text>
                    {t('messages.birthdatePreferenceDisclaimerUnknown')}
                </Text>
            )}
            {isBDFocused && isUser && (
                <div>
                    <Text>
                        {t('messages.birthdatePreferenceDisclaimerUser')}
                    </Text>
                    <Link
                        className="underline"
                        to={`/${t('routes.account')}`}
                        reloadDocument
                    >
                        {t('messages.birthdatePreferenceDisclaimerLink')}
                    </Link>
                </div>
            )}
        </div>
    );
};
